// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CpPiEOdVAho4rAAH{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CpPiEOdVAho4rAAH`
};
export default ___CSS_LOADER_EXPORT___;
